import React, { useState, useEffect } from "react";
import "./styles.css";
import Icon from "../Icon";

const MonthCarousel = ({ onSelectMonth }) => {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [months, setMonths] = useState([]);

  useEffect(() => {
    const currentMonthIndex = new Date().getMonth(); // Mês atual (0-11)
    const allMonths = [
      { name: "JAN", index: 0 }, { name: "FEV", index: 1 }, { name: "MAR", index: 2 },
      { name: "ABR", index: 3 }, { name: "MAI", index: 4 }, { name: "JUN", index: 5 },
      { name: "JUL", index: 6 }, { name: "AGO", index: 7 }, { name: "SET", index: 8 },
      { name: "OUT", index: 9 }, { name: "NOV", index: 10 }, { name: "DEZ", index: 11 }
    ];

    // Remove os meses que já passaram
    const availableMonths = allMonths.slice(currentMonthIndex);
    setMonths(availableMonths);
  }, []);

  const handleMonthClick = (month) => {
    setSelectedMonth(month.name);
    if (onSelectMonth) {
      onSelectMonth(month.index);
    }
  };

  const handlePrev = () => {
    setStartIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prevIndex) => Math.min(prevIndex + 1, months.length - 5));
  };

  return (
    <div className="carousel-container">
      <button className="carousel-button" onClick={handlePrev} disabled={startIndex === 0}>
        <Icon name="chevronLeft" size={20} className="icon-spacing" />
      </button>
      
      <div className="months-container">
        {months.slice(startIndex, startIndex + 5).map((month) => (
          <button
            key={month.index}
            onClick={() => handleMonthClick(month)}
            className={`month-button ${selectedMonth === month.name ? "selected" : ""}`}
          >
            {month.name}
          </button>
        ))}
      </div>

      <button className="carousel-button" onClick={handleNext} disabled={startIndex + 5 >= months.length}>
        <Icon name="chevronRight" size={20} className="icon-spacing" />
      </button>
    </div>
  );
};

export default MonthCarousel;
